/**
 * Modal de actualización controlada para el panel administrativo.
 * @module components/common/AppVersionUpdateModal
 */

import React from 'react';
import ConfirmDialog from './ConfirmDialog';

const AppVersionUpdateModal = ({
  isOpen,
  onUpdateNow,
  onPostpone,
  loading = false
}) => (
  <ConfirmDialog
    isOpen={isOpen}
    title="Actualización disponible"
    message={
      <p className="text-sm text-e0e3-muted leading-relaxed">
        Hay una actualización disponible.
        Podés actualizar ahora o posponer 5 minutos.
      </p>
    }
    confirmText="Actualizar ahora"
    cancelText="Posponer 5 minutos"
    onConfirm={onUpdateNow}
    onCancel={onPostpone}
    confirmColor="primary"
    loading={loading}
  />
);

export default AppVersionUpdateModal;
